import {z} from 'zod';
import {Date} from './date';

export const PaymentPlan = z.object({
  amount: z.number(),
  dueFrom: Date,
  dueUntil: Date,
  type: z.number(),
  numberOfRates: z.number(),
});

export type PaymentPlan = z.infer<typeof PaymentPlan>;
